import { render, staticRenderFns } from "./oneroster1.vue?vue&type=template&id=cecc76f4&scoped=true&"
import script from "./oneroster1.ts?vue&type=script&lang=ts&"
export * from "./oneroster1.ts?vue&type=script&lang=ts&"
import style0 from "./oneroster1.scss?vue&type=style&index=0&id=cecc76f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecc76f4",
  null
  
)

export default component.exports